import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const PostCallOutcomeModalSkeleton: React.FC = () => {
  const sProps = { enableAnimation: true };

  return (
    <div className="bs-post-call-outcome-modal__skeleton">
      {/* Prospect row */}
      <div className="bs-post-call-outcome-modal__skeleton-row">
        <SkeletonLoading width={48} height={48} circle {...sProps} />
        <SkeletonLoading width={120} height={16} {...sProps} />
      </div>

      {/* Call Via */}
      <div className="bs-post-call-outcome-modal__skeleton-field">
        <SkeletonLoading width={60} height={12} {...sProps} />
        <SkeletonLoading width={140} height={14} {...sProps} />
      </div>

      {/* Call Outcome */}
      <div className="bs-post-call-outcome-modal__skeleton-field">
        <SkeletonLoading width={80} height={12} {...sProps} />
        <SkeletonLoading width="100%" height={36} {...sProps} />
      </div>

      {/* Note */}
      <div className="bs-post-call-outcome-modal__skeleton-field">
        <SkeletonLoading width={30} height={12} {...sProps} />
        <SkeletonLoading width="100%" height={80} {...sProps} />
      </div>
    </div>
  );
};

export default PostCallOutcomeModalSkeleton;
